import React, { useEffect, useState } from "react";
import Service from "../../Services/service";
import { toast } from 'react-toastify';
// import { saveAs } from 'file-saver';

function ProofOfPlayReportComponent() {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Filters
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [mediaName, setMediaName] = useState("");
    const [layoutName, setLayoutName] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [regionId, setRegionId] = useState("");
    const [minDuration, setMinDuration] = useState(0);

    // Paging & Sorting
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchReport();
    }, [pageNumber, pageSize]);

const fetchReport = async () => {
    setLoading(true);
    try {
        const params = new URLSearchParams({
            startDate: startDate || '',
            endDate: endDate || '',
            mediaName: mediaName || '',
            layoutName: layoutName || '',
            displayName: displayName || '',
            regionId: regionId || '',
            minDuration: minDuration || 0,
            sortBy : 'StartTime',
            sortDescending : false,
            pageNumber: pageNumber.toString(),
            pageSize: pageSize.toString(),
        });

        const url = `Dashboard/Report?${params.toString()}`;
        const res = await Service.getdata(url);
        if (res) {
            setReportData(res.data.items);
            setTotalPages(res.data.totalPages);
        }
    } catch (error) {
        toast.error(`Failed to fetch report data: ${error.message}`);
        console.error(error.response?.data || error);
    } finally {
        setLoading(false);
    }
};



    const formatDateTime = (value) => {
        return new Date(value).toLocaleString("en-IN");
    };

    const exportCSV = () => {
        let csv = "Media,Layout,Display,Region,Start Time,End Time,Duration\n";
        reportData.forEach(item => {
            csv += `"${item.mediaName}","${item.layoutName}","${item.displayName}","${item.regionId}","${formatDateTime(item.startTime)}","${formatDateTime(item.endTime)}",${item.durationSeconds}\n`;
        });
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
       // saveAs(blob, "ProofOfPlayReport.csv");
    };

    const handlePageChange = (nextPage) => {
        if (nextPage >= 1 && nextPage <= totalPages) {
            setPageNumber(nextPage);
        }
    };

    return (
        <div className="container-fluid content-top-gap">
            <div className="card card_border mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Proof of Play Report</h5>
                    {/* <button className="btn btn-outline-success btn-sm" onClick={exportCSV}>Export CSV</button> */}
                </div>
                <div className="card-body">
                    {/* Filters */}
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <label>Start Date</label>
                            <input type="date" className="form-control" value={startDate} onChange={e => setStartDate(e.target.value)} />
                        </div>
                        <div className="col-md-3">
                            <label>End Date</label>
                            <input type="date" className="form-control" value={endDate} onChange={e => setEndDate(e.target.value)} />
                        </div>
                        <div className="col-md-3">
                            <label>Media Name</label>
                            <input type="text" className="form-control" value={mediaName} onChange={e => setMediaName(e.target.value)} />
                        </div>
                        <div className="col-md-3">
                            <label>Layout Name</label>
                            <input type="text" className="form-control" value={layoutName} onChange={e => setLayoutName(e.target.value)} />
                        </div>
                        <div className="col-md-3 mt-2">
                            <label>Display Name</label>
                            <input type="text" className="form-control" value={displayName} onChange={e => setDisplayName(e.target.value)} />
                        </div>
                        {/* <div className="col-md-3 mt-2">
                            <label>Region ID</label>
                            <input type="text" className="form-control" value={regionId} onChange={e => setRegionId(e.target.value)} />
                        </div> */}
                        <div className="col-md-3 mt-2">
                            <label>Min Duration (s)</label>
                            <input type="number" className="form-control" value={minDuration} onChange={e => setMinDuration(e.target.value)} />
                        </div>
                        <div className="col-md-3 mt-4 d-flex align-items-end">
                            <button className="btn btn-primary btn-sm w-100" onClick={() => { setPageNumber(1); fetchReport(); }}>Search</button>
                        </div>
                    </div>

                    {/* Table */}
                    {loading ? (
                        <div className="text-center"><div className="spinner-border" /></div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>Media</th>
                                        <th>Layout</th>
                                        <th>Display</th>
                                        {/* <th>Region</th> */}
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Duration (s)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.length === 0 ? (
                                        <tr><td colSpan={7} className="text-center">No data found</td></tr>
                                    ) : (
                                        reportData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.mediaName}</td>
                                                <td>{item.layoutName}</td>
                                                <td>{item.displayName}</td>
                                                {/* <td>{item.regionId}</td> */}
                                                <td>{formatDateTime(item.startTime)}</td>
                                                <td>{formatDateTime(item.endTime)}</td>
                                                <td>{item.durationSeconds}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Pagination */}
                    <div className="text-center mt-3">
                        <button
                            className="btn btn-outline-primary btn-sm mx-2"
                            onClick={() => handlePageChange(pageNumber - 1)}
                            disabled={pageNumber === 1}
                        >Previous</button>
                        <span>Page {pageNumber} of {totalPages}</span>
                        <button
                            className="btn btn-outline-primary btn-sm mx-2"
                            onClick={() => handlePageChange(pageNumber + 1)}
                            disabled={pageNumber === totalPages}
                        >Next</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProofOfPlayReportComponent;
